module.exports = __webpack_public_path__ + "img/COD.394222df.svg";